export class UserRequestModel {

  public userName: string;
  public pasWord: string;

}



// WEBPACK FOOTER //
// ./src/app/models/user-request.model.ts